function NotFound() {
    return (
      <>
       Not Found 404
      </>
    );
  }
  
  export default NotFound;
  